import { DefinedPropertyObject, IEntityMinimalModel } from "../../../api/GenericTypes";
import { IconNMRHolder, IconNMRHolderFilters, IconNMRHolderStatus } from "../../../api/IconNMR";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { EntityFilterSideBar } from "../../../common/sidebar/filtersidebar/EntityFilterBar";
import { SelectFormField } from "../../../common/formfields/SelectFormField";

export interface IconNMRHoldersFilterForm {
  dataSource?: IEntityMinimalModel[] | undefined | null;
  status?: IEntityMinimalModel<IconNMRHolderStatus>[] | undefined | null;
}

export const iconNMRHoldersDefaultValues: DefinedPropertyObject<IconNMRHoldersFilterForm> = {
  dataSource: null,
  status: null,
};

const defaultFilters = {
  searchTerm: "",
  sortBy: [{ property: "QUEUE_POSITION", sortDirection: "DESC" }],
} as IconNMRHolderFilters;

export const iconNMRHoldersFormToFilters = (form: IconNMRHoldersFilterForm): IconNMRHolderFilters => {
  let filters: IconNMRHolderFilters = {};
  filters.dataSourceIds =
    Array.isArray(form.dataSource) && form.dataSource.length > 0 ? form.dataSource.map((d) => d.id) : null;
  filters.statuses = Array.isArray(form.status) && form.status.length > 0 ? form.status.map((d) => d.id) : null;
  return filters;
};
/**
 * Converts filters to form values for IconNMRHolders.
 *
 * @param filters - The filters to convert.
 * @returns The form values.
 * @author @CorradoSurmanowicz
 */
export const iconNMRHoldersFiltersToForm = (filters: IconNMRHolderFilters): IconNMRHoldersFilterForm => {
  let form: IconNMRHoldersFilterForm = {};

  form.dataSource = filters.dataSourceIds?.map((id) => ({ id, name: "" })) ?? null;
  form.status = filters.statuses?.map((id) => ({ id, name: "" })) ?? null;

  return form;
};
export const IconNMRHoldersFilterbar = ({
  initialValues,
  onFormChange,
  dispatchTabStore,
  tabsLoading,
  currentTab,
  hideReset = false,
}: TabStoreFilterSidebarProps<IconNMRHolder, IconNMRHoldersFilterForm, IconNMRHolderFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={iconNMRHoldersDefaultValues}
      defaultFilters={defaultFilters}
      formToFilters={iconNMRHoldersFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, register, onReset }) => (
        <EntityFilterSideBar onReset={onReset} hideReset={hideReset}>
          <SelectFormField
            id={"status"}
            label={"Status"}
            {...register}
            items={[
              {
                id: "Submitted",
                name: "Submitted",
              },
              {
                id: "Running",
                name: "Running",
              },
            ]}
            control={control}
            horizontal={false}
            isMulti={true}
            placeholder="Select status..."
            isDisabled={currentTab !== "default"}
          />
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
